/*
 * @创建文件时间: 2020-02-03 12:22:24
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-05-09 09:47:03
 * @联系Qq:1638245306
 * @文件介绍: 计量支付
 */
export default [{
    path: 'paymentProjectProgress',
    name: 'paymentProjectProgress',
    meta: {
        title: '工程进度表',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/measurementAndPayment/paymentProjectProgress')
}, {
    path: 'paymentSummary',
    name: 'paymentSummary',
    meta: {
        title: '中间计量支付汇总表',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/measurementAndPayment/paymentSummary')
}, {
    path: 'paymentInterim',
    name: 'paymentInterim',
    meta: {
        title: '清单中期支付',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/measurementAndPayment/paymentInterim')
}, {
    path: 'paymentFinancialInterim',
    name: 'paymentFinancialInterim',
    meta: {
        title: '财务中期支付报表',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/measurementAndPayment/paymentFinancialInterim')
}]